<template>
  <div v-if="thisEnvId == 'takamatsu' && ($route.name == 'content'|| $route.name == 'sp_content')">
    <v-card v-if="this.$mq!=='sp'">
      <v-toolbar
        flat
        color="primary"
        dark
      >
        <v-toolbar-title>各年度事業報告</v-toolbar-title>
      </v-toolbar>
      <v-tabs :vertical="this.$mq!=='sp'">
        <v-tab>
          令和3年度
        </v-tab>
        <v-tab>
          令和2年度
        </v-tab>
        <v-tab>
          令和元年度
        </v-tab>
        <v-tab>
          平成30年度
        </v-tab>
        <v-tab>
          平成29年度
        </v-tab>

        <v-tab-item>
          <v-card flat>
            <vue-pdf-embed :style="'display: flex; overflow: scroll'" :width="this.$mq==='sp' ? 350 : 600" key="pdfr3" source="https://firebasestorage.googleapis.com/v0/b/liqlid-takamatsu2.appspot.com/o/contents%2F%E4%BB%A4%E5%92%8C3%E5%B9%B4%E5%BA%A6%E4%BA%8B%E6%A5%AD%E5%A0%B1%E5%91%8A.pdf?alt=media&token=45eccad8-ff5b-414e-b0c3-5a66ce268050" />
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <vue-pdf-embed :style="'display: flex; overflow: scroll'" :width="this.$mq==='sp' ? 350 : 600" key="pdfr2" source="https://firebasestorage.googleapis.com/v0/b/liqlid-takamatsu2.appspot.com/o/contents%2F%E4%BB%A4%E5%92%8C2%E5%B9%B4%E5%BA%A6%E4%BA%8B%E6%A5%AD%E5%A0%B1%E5%91%8A.pdf?alt=media&token=7048a16a-df3b-485b-87d4-d2fa370ebf61" />
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <vue-pdf-embed :style="'display: flex; overflow: scroll'" :width="this.$mq==='sp' ? 350 : 600" key="pdfr1" source="https://firebasestorage.googleapis.com/v0/b/liqlid-takamatsu2.appspot.com/o/contents%2F%E4%BB%A4%E5%92%8C%E5%85%83%E5%B9%B4%E5%BA%A6%E4%BA%8B%E6%A5%AD%E5%A0%B1%E5%91%8A.pdf?alt=media&token=1f9ac310-17fb-4d20-ab36-da241d5e8d4f" />
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <vue-pdf-embed :style="'display: flex; overflow: scroll'" :width="this.$mq==='sp' ? 350 : 600" key="pdfh30" source="https://firebasestorage.googleapis.com/v0/b/liqlid-takamatsu2.appspot.com/o/contents%2F%E5%B9%B3%E6%88%9030%E5%B9%B4%E5%BA%A6%E4%BA%8B%E6%A5%AD%E5%A0%B1%E5%91%8A.pdf?alt=media&token=861b1fd3-93fc-486c-9d60-b1d9da4a5ccf" />
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <vue-pdf-embed :style="'display: flex; overflow: scroll'" :width="this.$mq==='sp' ? 350 : 600" key="pdfh29" source="https://firebasestorage.googleapis.com/v0/b/liqlid-takamatsu2.appspot.com/o/contents%2F%E5%B9%B3%E6%88%9029%E5%B9%B4%E5%BA%A6%E4%BA%8B%E6%A5%AD%E5%A0%B1%E5%91%8A.pdf?alt=media&token=6b6e86fe-b54f-431e-b97d-d38464b1016d" />
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
    <v-card v-else>
      <v-toolbar
        flat
        color="primary"
        dark
      >
        <v-toolbar-title>各年度事業報告</v-toolbar-title>
      </v-toolbar>
      <v-tabs>
        <v-tab>
          令和3年度
        </v-tab>
        <v-tab>
          令和2年度
        </v-tab>
        <v-tab>
          令和元年度
        </v-tab>
        <v-tab>
          平成30年度
        </v-tab>
        <v-tab>
          平成29年度
        </v-tab>

        <v-tab-item>
          <v-card flat>
            <iframe key="pdf1" src="https://drive.google.com/file/d/1f_xPvXnzJbkxH0TQxtppyW-NVDcqELkB/preview" style="width: 100%;height: 80vh;"></iframe>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <iframe key="pdf2" src="https://drive.google.com/file/d/1zqW983RvfD-k5FvNSfxlMyoB3eg4fnuj/preview" style="width: 100%;height: 80vh;"></iframe>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <iframe key="pdf3" src="https://drive.google.com/file/d/1u5r3M3O3qx4x6iPxFG1_JZrDYSWmTWnu/preview" style="width: 100%;height: 80vh;"></iframe>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <iframe key="pdf4" src="https://drive.google.com/file/d/1cqk0dwloIgcn84Vtk_wG2H4hQlH6UAhX/preview" style="width: 100%;height: 80vh;"></iframe>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <iframe key="pdf5" src="https://drive.google.com/file/d/1oAvUbW3QJxIrLYOQ1ISciylD4pjkRhUR/preview" style="width: 100%;height: 80vh;"></iframe>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>

<script>
import Vue from 'vue'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import firebase from 'firebase'
import VueMq from 'vue-mq'

Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sp: 959,
    pc: 960
  },
  defaultBreakpoint: 'pc' // customize this for SSR
})


export default {
  components: {
    VuePdfEmbed
  },
  data: () => ({
    loading: true,
    thisEnvId: process.env.VUE_APP_TEMP_CITY_ID || '',  // dopplerのenvironment idと同値
  }),
  // 読み込みを1秒遅延させる
  created() {
    setTimeout(() => {
      this.loading = false
    }, 2000)
  },
}
</script>